<template>
  <div class="confirm">
    <Flow v-bind:step="4"/>
    <Loading
      v-show="loading"
      :title="submitting ? '決済処理中です' : ''"
      :message="submitting ? '完了画面が表示されるまで、ホームボタンの操作や他のアプリへの切り替えは行わず、この画面を表示したままお待ちください。' : ''"
    />
    <ConfirmProductsList :edit="true" />
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配達日指定</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">{{ userData.deliveryDate ? userData.deliveryDate : '指定配達日なし' }}</p>
        <router-link class="edit btn_yellow btn_mini" :to="{ name: 'purchaseSelectPaymentAndShipping' }">編集</router-link>
      </div>
    </div>
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送時間指定</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">{{ this.userData.shippingTime }}</p>
        <router-link class="edit btn_yellow btn_mini" :to="{ name: 'purchaseSelectPaymentAndShipping' }">編集</router-link>
      </div>
    </div>
    <div class="confirm_address bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送住所</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.shippingName }}</p>
          <p class="data_contents">〒{{ this.userData.shippingZip }} {{ this.userData.shippingAddress }}</p>
        </div>
        <router-link class="edit btn_yellow btn_mini" :to="{ name: 'purchaseSelectPaymentAndShipping' }">編集</router-link>
      </div>
    </div>
    <div class="confirm_credit bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">お支払い情報</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.paymethod }}</p>
          <div v-if="this.userData.paymethod == 'クレジットカード'">
            <p class="data_contents">
              {{ splitPaymentText() }}
            </p>
            <p class="data_contents">
              {{ this.userData.cardNumber }}
              <CreditcardExpired :expired="userData.expired" :expireYearMonth="userData.expireYearMonth" />
            </p>
          </div>
        </div>
        <router-link v-if="this.userData.paymethod != '全額ウォレット支払い'" class="edit btn_yellow btn_mini" :to="{ name: 'purchaseSelectPaymentAndShipping' }">編集</router-link>
        <router-link v-else class="edit btn_yellow btn_mini" :to="{ name: 'PurchaseDiscount' }">編集</router-link>
      </div>
    </div>
    <div class="confirm_coupon bg_white mt12 pt16 pb16 bdb boxs1">
      <h2 class="content_title rb">クーポン</h2>
      <div v-if="userDetailCouponList.length">
        <div v-for="val in userDetailCouponList" class="confirm_wrap pl16 pr25 bdb">
          <p class="confirm_data rb">{{ val.couponName }}</p>
          <p class="coupon_text ab">使用数<span class="count rb">{{ val.useCount }}</span></p>
        </div>
      </div>
      <div v-else class="confirm_wrap pl16 pr25 bdb rb">クーポンは使用していません。</div>
      <div class="pr25">
        <router-link class="edit btn_yellow btn_mini" :to="{ name: 'PurchaseDiscount' }">編集</router-link>
      </div>
    </div>
    <div class="sum_total bg_white mt12 pt16 pb16">
      <h2 class="content_title sum">合計</h2>
      <AmountList />
      <p class="purchase_caution">
        確定ボタンをタップすると決済処理を開始します。<br>
        決済処理中はホームボタンの操作や他のアプリへの切り替えは行わず、この画面を表示したままお待ちください。
      </p>
      <a href="#" class="complete btn_blue" @click.stop.prevent="completeOrder()">確定</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'purchaseSelectPaymentAndShipping' }">戻る</router-link>
    </div>
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading';
import ErrorModal from '@/components/common/ErrorModal';
import Flow from '@/components/purchase/Flow';
import Purchase from '@/components/api/purchases';
import Config from '@/config/config';
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';
import PurchaseModel from '@/model/purchase/purchaseWallet';
import PurchaseWallet from '@/components/api/purchase/purchaseWallet';
import AmountList from '@/components/purchase/AmountList';
import ConfirmProductsList from '@/components/purchase/ConfirmProductsList';
import ConfirmText from '@/components/common/ConfirmText';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';

export default {
  props: ['detailData'],
  components: {
    Flow,
    Loading,
    ErrorModal,
    AmountList,
    ConfirmProductsList,
    ConfirmText,
    CreditcardExpired
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '注文に失敗しました。',
      loading: false,
      submitting: false,
      userData: {
        shippingTime: '',
        shippingZip: '',
        shippingName: '',
        shippingAddress: '',
        paymethod: '',
        payCount: 1,
        cardNumber: '',
        // couponList: [],
        couponName: '',
        couponUse: 0,
        expireYearMonth: null,
        expired: false,
        deliveryDate: '',
      },
      coupon: 0,
    }
  },
  methods: {
    editBCItem (bcNumber) {
      localStorage.setItem('nowBC', bcNumber);
      this.$store.commit('setPurchaseNowBC', bcNumber);
      this.$store.commit('setPurchaseCartBC', bcNumber);
    },

    setUserDetail(shippingTime, zip, addressName, address, paymentName, payCount, cardNo, expireYearMonth, expired, deliveryDate) {
      this.userData.shippingTime = shippingTime;
      this.userData.shippingZip = zip;
      this.userData.shippingName = addressName;
      this.userData.shippingAddress = address;
      this.userData.paymethod = paymentName;
      this.userData.payCount = payCount;
      this.userData.cardNumber = cardNo;
      this.userData.expireYearMonth = expireYearMonth;
      this.userData.expired = expired;
      this.userData.deliveryDate = deliveryDate;
    },
    createUserDetail () {
      let userDetail = JSON.parse(localStorage.getItem('userDetail'));
      console.log(this.detailData);
      if(this.detailData) {
        this.setUserDetail(
          this.detailData.deliveryTimeData.deliveryTimeName,
          this.detailData.deliveryAddressData.zipCode,
          this.detailData.deliveryAddressData.recipientName,
          this.detailData.deliveryAddressData.address,
          this.detailData.paymentData.paymentMethodName,
          this.detailData.paymentData.paymentCount,
          this.detailData.selectCreditData.cardNo,
          this.detailData.selectCreditData.expireYearMonth,
          this.detailData.selectCreditData.expired,
          this.detailData.deliveryDate.deliveryDateLabel,
          // this.detailData.couponList,
        );
      } else if(userDetail) {
        this.setUserDetail(
          userDetail.deliveryTimeData.deliveryTimeName,
          userDetail.deliveryAddressData.zipCode,
          userDetail.deliveryAddressData.recipientName,
          userDetail.deliveryAddressData.address,
          userDetail.paymentData.paymentMethodName,
          userDetail.paymentData.selectPaymentCount,
          userDetail.selectCreditData.cardNo,
          userDetail.selectCreditData.expireYearMonth,
          userDetail.selectCreditData.expired,
          userDetail.deliveryDate.deliveryDateLabel,
        );
      }
    },
    async completeOrder() {
      this.loading = true;
      this.submitting = true;
      console.log('注文確定');
      console.log(this.detailData);
      const data = PurchaseModel.requestData(this.detailData, this.purchaseWalletUseBirthMonthDiscount, this.purchaseWalletWalletAmount, this.userDetailCouponList, this.purchaseWalletBcShipmentFeeList);
      console.log(data);
      if(data) {
        await PurchaseWallet.createOrder(data).then((val) => {
          console.log('購入レスポンス');
          console.log(val);

          // 購入設定をVuexとlocalStorageに保存（推奨商品シミュレーション用）
          if (data.deliveryTimeId || val.paymentMethodId) {
            // 購入設定を初期化
            localStorage.removeItem('recommendationPurchaseSettings');

            const purchaseSettings = {
              deliveryTimeId: data.deliveryTimeId || 0,
              paymentMethodId: val.paymentMethodId || 0,
              timestamp: Date.now()
            };

            // Vuexに保存
            this.$store.commit('setRecommendationPurchaseSettings', purchaseSettings);

            // localStorageに永続化
            localStorage.setItem('recommendationPurchaseSettings', JSON.stringify(purchaseSettings));

            console.log('購入設定をVuexとlocalStorageに保存:', purchaseSettings);
          }

          this.loading = false;
          this.submitting = false;
          let messages;
          let errorList = [];

          if(val.status && val.status != 200) {


            this.errorMessage = '予期せぬエラーが発生しました。<br>しばらくしてから再度お試しください。';
            if(val.message != null) {
              this.errorMessage += val.message;
            }
            this.modalOpen();
            return false;
          } else {
            if(val == 'error') {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'OK') {
              messages = '注文が完了しました。';
            }

            if(val.resultStatus == 'ALL_NG') {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.errorMessage += val.errorMessage != null ? val.errorMessage : '';
              if(val.bcErrorList.length > 0) {
                for (var i = 0; i < val.bcErrorList.length; i++) {
                  this.errorMessage += '<br>BC' + val.bcErrorList[i].bcNo + ': ' + val.bcErrorList[i].errorMessage;
                }
              }
              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'ALL_NG' && val.discountError) {
              this.errorMessage = '受注作成でエラーが発生しました。';
              this.errorMessage += val.errorMessage != null ? val.errorMessage : '';
              if(val.bcErrorList.length > 0) {
                for (var i = 0; i < val.bcErrorList.length; i++) {
                  this.errorMessage += '<br>BC' + val.bcErrorList[i].bcNo + ': ' + val.bcErrorList[i].errorMessage;
                }
              }

              this.modalOpen();
              return false;
            }

            if(val.resultStatus == 'SOME_NG') {
              messages = '受注作成でエラーが発生しました。<br>お手数ですが再度やり直してください。';
              errorList.push(...val.bcErrorList);
            }

            this.$store.commit('setPurchaseBirthMonthDiscountPrice', val.birthMonthDiscountPrice);
          }



          this.$router.push({ name: 'purchaseComplete', params: {message: messages, errorList: errorList, useBirthMonthDiscount: val.useBirthMonthDiscount, recommendProductMap: val.recommendProductMap}});
        });

      }

    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    },
    // クレジットカード払いの時の分割払いテキスト表示用メソッド
    splitPaymentText() {
      return this.$store.state.userDetail.paymentData.selectPaymentCount === 1 ? "一括払い" : `分割払い（${this.userData.payCount}回）`
    },
    async confirmOrder() {
      this.loading = true;
      const data = PurchaseModel.requestData(this.detailData, this.purchaseWalletUseBirthMonthDiscount, this.purchaseWalletWalletAmount, this.userDetailCouponList, this.purchaseWalletBcShipmentFeeList);
      console.log('PurchaseWallet confirmOrder リクエスト内容');
      console.log(data);
      if(data) {
        await PurchaseWallet.confirmOrder(data).then((val) => {
          console.log('PurchaseWallet confirmOrder レスポンス');
          console.log(val);
          this.loading = false;
          if(val.status && val.status != 200) {
            this.errorMessage = '予期せぬエラーが発生しました。<br>しばらくしてから再度お試しください。';
            if(val.message != null) {
              this.errorMessage += val.message;
            }
            this.modalOpen();
            this.$store.commit('setPurchaseBirthMonthDiscountPrice', 0);
            this.$store.commit('setPurchaseCashOnDeliveryFee', 0);
            this.$store.commit('setPurchaseCouponDiscount', 0);
            this.$store.commit('setPurchaseShipmentFee', 0);
            this.$store.commit('setPurchaseUseBirthMonthDiscount', 0);
          } else {
            this.$store.commit('setPurchaseBirthMonthDiscountPrice', val.birthMonthDiscountPrice);
            this.$store.commit('setPurchaseCashOnDeliveryFee', val.cashOnDeliveryFee);
            this.$store.commit('setPurchaseCouponDiscount', val.couponDiscount);
            this.$store.commit('setPurchaseShipmentFee', val.shipmentFee);
            this.$store.commit('setPurchaseUseBirthMonthDiscount', val.useBirthMonthDiscount);
          }
        });
      }
    }
  },
  computed: mapGetters([
    'purchaseWalletUseBirthMonthDiscount',
    'purchaseWalletWalletAmount',
    'purchaseBirthMonthDiscountPrice',
    'purchaseCashOnDeliveryFee',
    'purchaseCouponDiscount',
    'purchaseShipmentFee',
    'purchaseUseBirthMonthDiscount',
    'userDetailCouponList',
    'purchaseWalletBcShipmentFeeList'
  ]),
  created () {
    this.createUserDetail();
    this.confirmOrder();
  },
};
</script>

<style lang="css" scoped>
.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}

.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}
.coupon_text {
  font-size: 12px;
  line-height: 1;
}
.count {
  font-size: 20px;
  margin-left: 25px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap {
  margin-top: 24px;
}
.confirm_coupon .confirm_wrap {
  margin-top: 30px;
}


.sum_total {
  padding-bottom: 48px;
}

.purchase_caution {
  color: red;
  font-size: 14px;
  line-height: 1.4;
  margin: 36px 24px 0;
  text-align: center;
}

.complete {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Confirm.vue